const ATTR_SIDEBAR_OUTBRAIN = 'data-adv';
const ADV_SIDEBAR_OUTBRAIN_SELECTOR = 'aside .s-outbrain';
const ADV_SIDEBAR_WRAPPER_SELECTOR = 'aside .s-adv-top-wrapper';
const ADV_SIDEBAR_WRAPPER_HEIGHT = document.querySelector(ADV_SIDEBAR_WRAPPER_SELECTOR)
  ? (document.querySelector(ADV_SIDEBAR_WRAPPER_SELECTOR) as HTMLElement).style.height
  : '40%';

export const advRefresh = (): void => {
  /**
   * ADV REFRESH relays on the presence of external "_4SDexRefresh()" function
   * Loaded from CDN https://cdnb.4strokemedia.com/dexRefresh.min.js
   * TS doesn't know of its existence, so...
   */
  // @ts-ignore
  if (typeof _4SDexRefresh === 'function') {
    // @ts-ignore
    _4SDexRefresh([{ w: 300, h: 250 }], [{ k: 'pos', v: 'ATF' }], false);
  } else {
    console.warn('[adv-refresh.ts] Function _4SDexRefresh() not found.'); // eslint-disable-line no-console
  }
};

export const advOutbrainShowHide = (tab: Element | null) => {
  if (tab) {
    const dataAttr: string | null = tab.getAttribute(ATTR_SIDEBAR_OUTBRAIN);
    const advElement: HTMLElement | null = document.querySelector(ADV_SIDEBAR_OUTBRAIN_SELECTOR);

    if (advElement) {
      advElement.style.display = dataAttr === null ? 'none' : 'block';
    }

    // Set HEIGHT=100% if OUTBRAIN ADV is ABSENT
    const advWrapper: HTMLElement | null = document.querySelector(ADV_SIDEBAR_WRAPPER_SELECTOR);
    if (advWrapper) {
      const advHeight = dataAttr === null ? '100%' : ADV_SIDEBAR_WRAPPER_HEIGHT;
      advWrapper.style.height = advHeight;
    }
  }
};
